import go from '@/gojs/gopher'

export default go
